import React from 'react';
import { Card, CardContent } from './ui/card';
import { Sparkles } from 'lucide-react';
import { authorBio } from '../data/mockBooks';

const AuthorBio = () => {
  return (
    <div className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-orange-100 px-6 py-2 rounded-full mb-4">
            <Sparkles className="h-4 w-4 text-orange-500" />
            <span className="text-sm font-semibold text-orange-700 tracking-wide">
              MEET THE AUTHOR
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-gray-900">
            About the Author - {authorBio.name}
          </h1>
        </div>

        <Card className="overflow-hidden shadow-2xl border-2 border-gray-100">
          <CardContent className="p-0">
            <div className="flex flex-col md:flex-row items-center gap-8 p-8 md:p-12">
              <div className="flex-shrink-0">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-orange-400 to-orange-600 rounded-full blur-2xl opacity-20"></div>
                  <img
                    src={authorBio.image}
                    alt={authorBio.name}
                    className="relative w-48 h-48 md:w-64 md:h-64 rounded-full object-cover shadow-2xl border-4 border-white"
                  />
                </div>
              </div>

              <div className="flex-1 space-y-6 text-center md:text-left">
                <h3 className="text-3xl font-bold text-gray-900">
                  {authorBio.name}
                </h3>
                
                <p className="text-lg text-gray-700 leading-relaxed">
                  {authorBio.bio}
                </p>

                <div className="flex flex-wrap gap-3 justify-center md:justify-start pt-4">
                  <span className="px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-semibold">
                    Puzzle Creator
                  </span>
                  <span className="px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-semibold">
                    Brain Games Expert
                  </span>
                  <span className="px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-semibold">
                    Author
                  </span>
                </div>

                <div className="pt-6 border-t border-gray-200">
                  <p className="text-sm text-gray-600 italic">
                    "My books are perfect for fans of word puzzles, educational activity books, 
                    and cognitive brain exercises, whether at home or on the go."
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AuthorBio;
